import React from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { t } from 'i18next'
import Navigation from 'Components/Navigation'
import useValidatePermission from 'Hooks/useValidatePermission'
import { VAPermissions, ROUTES } from 'Utils/constants'
import './CustomerDisplayInformation.css'
import CustomerDisplayInformation from './CustomerDisplayInformation'

export default function CustomerDisplayForm() {
  const hasSettingsPermission = useValidatePermission(VAPermissions.settingsVA)

  if (!hasSettingsPermission) {
    return <Redirect to={ROUTES.home} />
  }

  const { id } = useParams()
  const editMode = Boolean(id)

  return (
    <>
      <Navigation />
      <div className="customer-display-information-container">
        <h1>
          {editMode
            ? t('CUSTOMER_DISPLAY_SETTINGS.FORM.TITLE_EDIT')
            : t('CUSTOMER_DISPLAY_SETTINGS.FORM.TITLE_NEW')}
        </h1>
        <CustomerDisplayInformation id={id} editMode={editMode} />
      </div>
    </>
  )
}
